export default "__VITE_ASSET__DlQ_ShSe__"